import { OnboardingApplication, OnboardingFeature, OnboardingQuestion } from "../models/onboarding.model";
import { pythonApiClient, pythonPublicClient } from "./python-http-client.service";

export interface OnboardingCatalog {
  baseQuestions: OnboardingQuestion[];
  features: OnboardingFeature[];
  defaultRatePaise: number;
}

export const onboardingAdminApi = {
  catalog: async () => (await pythonApiClient.get<OnboardingCatalog>("/api/admin/onboarding/catalog")).data,
  list: async () => (await pythonApiClient.get<OnboardingApplication[]>("/api/admin/onboarding/applications")).data,
  create: async (payload: any) => (await pythonApiClient.post("/api/admin/onboarding/applications", payload)).data,
  regenerateInvite: async (id: string) => (await pythonApiClient.post(`/api/admin/onboarding/applications/${id}/regenerate-invite`)).data,
  decidePayment: async (id: string, decision: "verified" | "rejected", note = "") =>
    (await pythonApiClient.post(`/api/admin/onboarding/applications/${id}/payment-decision`, { decision, note })).data,
  paymentProofUrl: async (id: string) =>
    (await pythonApiClient.get(`/api/admin/onboarding/applications/${id}/payment-proof-url`)).data,
};

export const onboardingPublicApi = {
  get: async (token: string) => (await pythonPublicClient.get<OnboardingApplication>(`/api/onboarding/${token}`)).data,
  saveDraft: async (token: string, answers: Record<string, any>) =>
    (await pythonPublicClient.patch(`/api/onboarding/${token}/draft`, { answers })).data,
  uploadProof: async (token: string, proof: File) => {
    const body = new FormData();
    body.append("proof", proof);
    return (await pythonPublicClient.post(`/api/onboarding/${token}/payment-proof`, body)).data;
  },
  submit: async (token: string, payload: any) =>
    (await pythonPublicClient.post(`/api/onboarding/${token}/submit`, payload)).data,
};
